import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  company: [],
  loading: false,
  error: null,
};
const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    companyRequest(state) {
      state.loading = true;
      state.error = null;
    },
    companySuccess(state, action) {
      state.loading = false;
      state.company = action.payload;
    },
    companyAddSuccess(state, action) {
      state.loading = false;
      state.company.push(action.payload);
    },
    companyEditSuccess(state, action) {
      state.loading = false;
      state.company = state.company.map((company: { id: any }) =>
        company.id === action.payload.id ? action.payload : company
      );
    },
    companyDeleteSuccess(state, action) {
      state.loading = false;
      state.company = state.company.filter(
        (company: { id: any }) => company.id !== action.payload
      );
    },
    companyError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getCompanyByIdRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getCompanyByIdSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;
    },
    getCompanyByIdError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getBookingByCompanyIdSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;
    },
    getBookingByCompanyIdError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getBookingByCompanyIdRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getCustomerByCompanyIdRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getCustomerByCompanyIdError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getCustomerByCompanyIdSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;
    },

    CustomerByCompanyIdRequest(state) {
      state.loading = true;
      state.error = null;
    },
    CustomerByCompanyIdError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    CustomerByCompanyIdSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;
    },
   
  },
});

export const {
  companyRequest,
  companySuccess,
  companyAddSuccess,
  companyEditSuccess,
  companyDeleteSuccess,
  companyError,
  getCompanyByIdRequest,
  getCompanyByIdSuccess,
  getCompanyByIdError,
  getBookingByCompanyIdRequest,
  getBookingByCompanyIdSuccess,
  getBookingByCompanyIdError,
  getCustomerByCompanyIdRequest,
  getCustomerByCompanyIdError,
  getCustomerByCompanyIdSuccess,
  CustomerByCompanyIdRequest,
  CustomerByCompanyIdSuccess,
  CustomerByCompanyIdError,

} = companySlice.actions;

export default companySlice.reducer;
